<ng-container *ngIf="offers$ | async as cardlinkOffers">
  <ng-container *ngIf="cardlinkOffers.length > 0">
    <h2 *ngIf="labelName != ''" class="offers-you-may-like-heading fw-bold font-size-20">{{ labelName | translate }}</h2>
    <hr *ngIf="horizontalLine" class="horizontal-line" />
    <div class="row">
      <ng-container *ngFor="let cardLinkOffer of cardlinkOffers">
        <div class="col-12 col-lg-6">
          <fgbcl-card-link-offer-item [cardLinkOffer]="cardLinkOffer" [lcid]="lcid"></fgbcl-card-link-offer-item>
        </div>
      </ng-container>
    </div>
  </ng-container>
</ng-container>
<!--Show More Button-->
<ng-container *ngIf="cardLinkOfferOptions.offerType == 6 || cardLinkOfferOptions?.limit != 0">
  <ng-container *ngIf="showMoreButton && cardLinkOfferOptions.showMoreIncrement && cardLinkOfferOptions.limit">
    <div class="mt-3 cursor-pointer">
      <a
        class="show-more fw-bold d-flex align-item-center"
        (click)="
          cardLinkOfferOptions.limit = +cardLinkOfferOptions!.limit + +cardLinkOfferOptions!.showMoreIncrement; fetchOffers()
        "
      >
        <span class="icon material-icons fw-bold" aria-hidden="true">expand_more</span>
        {{ 'fgbcl.card.linking.offer.show.more.label' | translate }}
      </a>
    </div>
  </ng-container>
</ng-container>
